<template>
  <div class="admin-container">
    <h1>抽奖管理</h1>

    <div class="admin-sections-row">
      <div class="admin-section">
        <h2>参与人员管理</h2>
        <p>当前参与人员数量：{{ participantCount }}</p>
        <button class="clear-btn" @click="clearParticipants">清空参与人员列表</button>
      </div>

      <div class="admin-section">
        <h2>中奖名单管理</h2>
        <p>当前中奖记录数量：{{ winningCount }}</p>
        <div class="admin-actions">
          <button class="clear-btn" @click="clearWinningRecords">清空中奖名单</button>
          <button class="export-btn" @click="exportToExcel" :disabled="winningRecords.length === 0">
            导出Excel
          </button>
        </div>
      </div>
    </div>

    <div class="admin-section">
      <h2>中奖记录</h2>
      <div class="records-table-container">
        <table class="records-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>姓名</th>
              <th>手机号</th>
              <th>奖项等级</th>
              <th>奖品名称</th>
              <th>中奖时间</th>
            </tr>
          </thead>
        </table>
        <div class="records-table-body">
          <table class="records-table">
            <tbody>
              <tr v-for="(record, index) in winningRecords" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ record.name }}</td>
                <td>{{ record.phone }}</td>
                <td>{{ record.prizeLevel }}</td>
                <td>{{ record.prizeName }}</td>
                <td>{{ formatDateTime(record.createTime) }}</td>
              </tr>
              <tr v-if="winningRecords.length === 0">
                <td colspan="6" class="empty-message">暂无中奖记录</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="admin-section">
      <h2>操作记录</h2>
      <div class="log-container">
        <div v-for="(log, index) in logs" :key="index" class="log-item">
          {{ log }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'Admin',
  data() {
    return {
      participantCount: 0,
      winningCount: 0,
      winningRecords: [],
      logs: []
    };
  },
  mounted() {
    this.fetchParticipantCount();
    this.fetchWinningCount();
    this.fetchWinningRecords();
  },
  methods: {
    async fetchParticipantCount() {
      try {
        const response = await request.get('/api/participant/list', { params: { page: 1, size: 1 } });
        this.participantCount = response.data?.data?.total || 0;
        this.addLog('获取参与人员数量成功：' + this.participantCount);
      } catch (error) {
        console.error('获取参与人员数量失败：', error);
        this.addLog('获取参与人员数量失败');
      }
    },

    async fetchWinningCount() {
      try {
        const response = await request.get('/api/lottery/records', { params: { page: 1, size: 1 } });
        this.winningCount = response.data?.data?.total || 0;
        this.addLog('获取中奖记录数量成功：' + this.winningCount);
      } catch (error) {
        console.error('获取中奖记录数量失败：', error);
        this.addLog('获取中奖记录数量失败');
      }
    },
    async clearParticipants() {
      if (confirm('确定要清空参与人员列表吗？此操作不可恢复。')) {
        try {
          const response = await request.post('/api/participant/clear');
          if (response.data?.code === 200) {
            this.participantCount = 0;
            this.addLog('清空参与人员列表成功');
            alert('清空参与人员列表成功');
          } else {
            this.addLog('清空参与人员列表失败：' + response.data?.message);
            alert('清空参与人员列表失败：' + response.data?.message);
          }
        } catch (error) {
          console.error('清空参与人员列表失败：', error);
          this.addLog('清空参与人员列表失败：' + error.message);
          alert('清空参与人员列表失败：' + error.message);
        }
      }
    },

    async clearWinningRecords() {
      if (confirm('确定要清空中奖名单吗？此操作不可恢复。')) {
        try {
          const response = await request.post('/api/lottery/clear');
          if (response.data?.code === 200) {
            this.winningCount = 0;
            this.addLog('清空中奖名单成功');
            alert('清空中奖名单成功');
          } else {
            this.addLog('清空中奖名单失败：' + response.data?.message);
            alert('清空中奖名单失败：' + response.data?.message);
          }
        } catch (error) {
          console.error('清空中奖名单失败：', error);
          this.addLog('清空中奖名单失败：' + error.message);
          alert('清空中奖名单失败：' + error.message);
        }
      }
    },
    addLog(message) {
      const timestamp = new Date().toLocaleString();
      this.logs.unshift(`[${timestamp}] ${message}`);
      if (this.logs.length > 10) {
        this.logs.pop();
      }
    },

    async fetchWinningRecords() {
      try {
        const response = await request.get('/api/lottery/records', {
          params: { page: 1, size: 1000 } // 获取足够多的记录
        });

        if (response.data?.code === 200 && response.data?.data?.records) {
          this.winningRecords = response.data.data.records;
        }
      } catch (error) {
        console.error('获取中奖记录失败：', error);
        alert('获取中奖记录失败，请稍后重试');
      }
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '';
      const date = new Date(dateTime);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },

    exportToExcel() {
      if (this.winningRecords.length === 0) {
        alert('暂无中奖记录可导出');
        return;
      }

      // 生成Excel内容
      let csvContent = "序号,姓名,手机号,奖项等级,奖品名称,中奖时间\n";

      this.winningRecords.forEach((record, index) => {
        const row = [
          index + 1,
          record.name,
          record.phone,
          record.prizeLevel,
          record.prizeName,
          this.formatDateTime(record.createdAt)
        ];
        csvContent += row.join(',') + '\n';
      });

      // 创建下载链接
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', `中奖记录_${new Date().toLocaleDateString()}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
.admin-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.admin-sections-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.admin-sections-row .admin-section {
  flex: 1;
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
}

.admin-section {
  background-color: white;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #555;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

p {
  color: #666;
  margin-bottom: 20px;
}

.clear-btn {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.clear-btn:hover {
  background-color: #c82333;
}

.admin-actions {
  display: flex;
  gap: 10px;
}

.view-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.view-btn:hover {
  background-color: #0069d9;
}

.log-container {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  background-color: #f9f9f9;
}

.log-item {
  padding: 5px 0;
  border-bottom: 1px solid #eee;
  color: #666;
  font-size: 14px;
}

.log-item:last-child {
  border-bottom: none;
}

.records-table-container {
  margin-top: 20px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.records-table {
  width: 100%;
  border-collapse: collapse;
}

.records-table th,
.records-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
  min-width: 100px;
}

.records-table th {
  background-color: #f8f9fa;
  font-weight: bold;
  color: #333;
  border-bottom: 2px solid #dee2e6;
  position: sticky;
  top: 0;
  z-index: 1;
}

.records-table tr:hover {
  background-color: #f8f9fa;
}

.records-table .empty-message {
  text-align: center;
  color: #666;
  padding: 40px;
  font-style: italic;
}

.records-table-body {
  max-height: 40vh;
  overflow-y: auto;
}

.records-table-body table {
  border-top: none;
}

.records-table-body table td {
  border-top: none;
}

.export-btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.export-btn:hover:not(:disabled) {
  background-color: #218838;
}

.export-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}
</style>